<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  [ngStyle]="overrideStyle"
>
  <path
    d="M5.01904 12.5812C5.01904 13.0005 5.50401 13.2336 5.83139 12.9717L11.281 8.61197C11.5312 8.4118 11.5312 8.03126 11.281 7.8311L5.83139 3.47141C5.50401 3.20951 5.01904 3.44259 5.01904 3.86185V12.5812Z"
    fill="white"
  />
  <path
    d="M12.3515 3.22778C12.8469 3.22778 13.2686 3.5063 13.2686 3.85556V12.5074C13.3021 13.3429 11.3608 13.3429 11.3942 12.5074V3.85556C11.3608 3.5063 11.8227 3.22778 12.3515 3.22778Z"
    fill="white"
  />
</svg>
